import { SelectProps } from 'antd';
import { useState } from 'react';
import { useDebounce } from '@/hooks';
import InfiniteSelect from '@/components/_common/InfiniteSelect';
import useSelectOptions from '@/hooks/useSelectOptions';
import { InvoiceCarrierListRequest } from '@/core/domain/invoice/invoiceCarrier/invoiceCarrier.types';
import {
  useInvoiceCarrier,
  useInvoiceCarriers,
} from '@/core/domain/invoice/invoiceCarrier/invoiceCarrier.hooks';
import { applyCpfCnpjMask } from '@/utils/mask';

type Props = Omit<SelectProps, 'options'> & {
  queryFilter?: InvoiceCarrierListRequest;
  queryEnable?: boolean;
};

const CarrierSelectField: React.FC<Props> = ({
  queryFilter,
  queryEnable = false,
  ...props
}) => {
  const [selectClicked, setSelectClicked] = useState<boolean>(false);

  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  const carrierList = useInvoiceCarriers(
    {
      rows: 10,
      name: search,
      ...queryFilter,
    },
    (queryEnable || selectClicked) && !props.disabled,
  );

  const carrierDetail = useInvoiceCarrier(props.value);

  const options = useSelectOptions({
    list: carrierList,
    detail: carrierDetail,
    selectProps: props,
    labelFormatter: (carrier) => (
      <div>
        <div>{carrier.name}</div>
        <div style={{ fontSize: 14, opacity: 0.6 }}>
          {carrier.cpfCnpj ? applyCpfCnpjMask(carrier.cpfCnpj) : '-'}
        </div>
      </div>
    ),
  });

  return (
    <InfiniteSelect
      fetchNextPage={carrierList.fetchNextPage}
      hasNextPage={carrierList.hasNextPage}
      loading={carrierList.isLoading}
      options={options}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      allowClear
      onSelect={() => setSelectClicked(false)}
      onDropdownVisibleChange={(open) => setSelectClicked(open)}
      {...props}
    />
  );
};

export default CarrierSelectField;
